
export const TYPE_SET_MESSAGES        = 'chats.messages.set';
export const TYPE_SET_CHAT            = 'chats.set';
export const TYPE_SET_CHATS           = 'chats.set.many';
export const TYPE_SET_OPEN_CHAT       = 'chats.set.whichIsOpen';
export const TYPE_SET_SEARCH          = 'chats.set.search';
export const TYPE_SET_TMP_MESSAGE     = 'chats.set.newTmpMessage';
export const TYPE_SET_CHAT_PAGINATION = 'chats.set.pagination';
export const TYPE_ADD_NEW_MESSAGE     = 'chats.add.newMessage';
